import React, { Component } from 'react';
import { connect } from 'react-redux'

import Slide from './Slides';

const mapStateToProps = state => {
  return {
    activeSlide: state.slides.activeSlide,
    allSlides: state.slides.allSlides
  };
};

class App extends Component {
  render() {
    return (
      <div>
        <Slide { ...this.props.activeSlide }/>
      </div>
    );
  }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js